<template>

<form id="osForm" class="mx-auto col-sm-8 col-lg-12" @submit.prevent>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
      <Combobox
        disabled
        name='garage_accredited'
        :options="garages"
        :initial-value="os.garageAccredited"
        label="fantasyName"
        v-model="os.garageAccredited"
        :reduce="garage => garage.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="technical_user">{{ $t('technical_user') }}</label>
      <Combobox
        disabled
        name='technical_user'
        :options="usersGarageAccredited"
        :initial-value="os.technicalUsers"
        label="name"
        v-model="os.technicalUsers"
        :reduce="users => users.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="serial">{{ $t('serial') }}</label>
      <input
        disabled
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_serial')"
        v-model="os.serial"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-8">
      <label for="contract">{{ $t('contract') }}</label>
      <Combobox
        disabled
        name='contract'
        :options="contracts"
        :initial-value="os.contract"
        label="contracts"
        v-model="os.contract"
        :reduce="contract => contract.id_contrato"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="board">{{ $t('board') }}</label>
      <the-mask
        disabled
        type="text"
        id="board"
        name="board"
        class="form-control"
        v-model="os.board"
        mask="LLLNXNN"
        :tokens="getTokenBoard"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="brand">{{ $t('brand') }}</label>
      <input
        disabled
        type="text"
        name='brand'
        class="form-control"
        v-model="os.brand.name"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="model">{{ $t('model') }}</label>
      <input
        disabled
        type="text"
        id="model"
        name="model"
        class="form-control"
        v-model="os.model"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="color">{{ $t('color') }}</label>
      <input
        disabled
        type="text"
        id="color"
        name="color"
        class="form-control"
        v-model="os.color"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="year">{{ $t('year') }}</label>
      <Combobox
        disabled
        name='year'
        :options="years"
        :initial-value="os.year"
        v-model="os.year"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="vehicle_type">{{ $t('vehicle_type') }}</label>
      <Combobox
        disabled
        name='vehicle_type'
        label='TPV_DSC'
        :options="vehicletypes"
        :reduce="vehicleType => vehicleType.TPV_COD"
        :initial-value="os.vehicleType"
        v-model="os.vehicleType"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="odometer">{{ $t('odometer') }}</label>
      <CurrencyInput
        disabled
        id='odometer'
        name='odometer'
        v-model="os.odometer"
        :currency='null'
        :precision=1
        :auto-decimal-mode="true"
        class=" form-control"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="services">{{ $t('services') }}</label>
      <Combobox
        disabled
        name='services'
        label='name'
        :options="servicetypes"
        :reduce="serviceType => serviceType.id"
        :initial-value="os.services"
        v-model="os.services"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="reason">{{ $t('reason') }}</label>
      <Combobox
        disabled
        name='reason'
        label='name'
        :options="maintancereasons"
        :reduce="maintanceReason => maintanceReason.id"
        :initial-value="os.maintanceReason"
        v-model="os.maintanceReason"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="withdrawn_serial">{{ $t('withdrawn_serial') }}</label>
      <input
        disabled
        type="text"
        id="withdrawn_serial"
        name="withdrawn_serial"
        class="form-control"
        v-model="os.withdrawnSerial"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="travel_payment">{{ $t('travel_payment') }}</label>
      <Combobox
        disabled
        name='travel_payment'
        label='name'
        :options="[{ name: 'SIM', value: true }, { name: 'NÃO', value: false }]"
        :reduce="travelPayment => travelPayment.value"
        :initial-value="os.travelPayment"
        v-model="os.travelPayment"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="tracker_installation_local">{{ $t('tracker_installation_local') }}</label>
      <input
        disabled
        type="text"
        name="tracker_installation_local"
        class="form-control"
        :placeholder="$t('ph_tracker_installation_local')"
        v-model="os.trackerInstallationLocal"
      />
    </div>

    <div class="col-lg-2 text-lg-center text-md-center text-sm-left">
      <label for="latitude"></label>
      <input
        readonly
        class="form-control-plaintext text-center"
        value='Latitude: 0'
      >
    </div>

    <div class="col-lg-2 text-lg-right text-md-right text-sm-left">
      <label for="longitude"></label>
      <label for="latitude"></label>
      <input
        readonly
        class="form-control-plaintext text-center"
        value='Longitude: 0'
      >
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <label for="obs">{{ $t('obs') }}</label>
      <textarea
        disabled
        name="obs"
        id="obs"
        rows="3"
        class="form-control"
        v-model="os.obs"
      />
    </div>
  </div>

  <div class="row mt-3 mb-3">
    <div class="col-lg-10 col-sm-4">
      <h3>Lista de ativos</h3>
    </div>
  </div>

  <table class="table table-sm table-hover table-bordered white-bg">
    <thead>
      <tr>
        <th scope="col" class="col">{{ $t('active') }}</th>
        <th scope="col">{{ $t('serial') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="active in actives" :key="active.id">
        <td>{{ active.model.name }}</td>
        <td>{{ active.serie }}</td>
      </tr>
    </tbody>
  </table>

  <div class="form-group row mt-3">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        Voltar
      </LoaderButton>
    </div>
  </div>

</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import years from '@/config/years.js'
import location from '@/config/locations'

export default {
  name: 'OsForm',
  components: {
    LoaderButton,
    Combobox
  },
  data () {
    return {
      usersGarageAccredited: [],
      years,
      getTokenBoard: {
        'L': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
        'N': {pattern: /[0-9]/},
        'X': {pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase()}
      },
    }
  },
  props: {
    os: {
      type: Object,
      default: () => ({
        id: undefined,
        garageAccredited: undefined,
        technicalUsers: undefined,
        serial: '',
        contract: undefined,
        board: '',
        brand: '',
        model: '',
        color: '',
        year: '',
        vehicleType: '',
        odometer: undefined,
        services: undefined,
        maintanceReason: undefined,
        withdrawnSerial: undefined,
        travelPayment: undefined,
        obs: '',
        activeList: [],
        trackerInstallationLocal: ''
      })
    }
  },
  computed: {
    ...mapState({
      oss: state => state.os.all,
      garages: state => state.garageaccredited.all,
      vehicletypes: state => state.vehicletypes.all,
      maintancereasons: state => state.maintancereason.all,
      contracts: state => state.contracts.all,
      servicetypes: state => state.servicetypes.all,
      actives: state => state.active.all,
    })
  },
  methods: {
    ...mapActions('os', [ 'cleanState' ]),

    async searchUsersGarageAccredited (id) {
      if (id) {
        const users = await this.$store.dispatch('garageaccredited/fetchById', id)

        this.usersGarageAccredited = users.users.map(e => {
          return { ...this.usersGarageAccredited, id: e.id, name: e.name }
        })
      }
    },

    async onClick (evtClick, doneFn) {
      this.$router.push({ name: 'listos' })
    },
  },
  async mounted () {
    this.$store.dispatch('overlay/show', true)
    await this.$store.dispatch('active/fetchFilteredForOs', { idOs: this.os.id, isActive: false })
    this.$store.dispatch('garageaccredited/fetchAll')
    if (this.os.garageAccredited) this.searchUsersGarageAccredited(this.os.garageAccredited)
    await this.$store.dispatch('contracts/fetchAll')
    await this.$store.dispatch('vehicletypes/fetchAll')
    await this.$store.dispatch('maintancereason/fetchAll')
    await this.$store.dispatch('servicetypes/fetchAll')

    this.$store.dispatch('overlay/show', false)
  },
  destroyed () {
    this.$store.dispatch('garageaccredited/cleanState')
    this.$store.dispatch('vehicletypes/cleanState')
    this.$store.dispatch('maintancereason/cleanState')
    this.$store.dispatch('contracts/cleanState')
    this.$store.dispatch('servicetypes/cleanState')
    this.$store.dispatch('ostests/cleanState')
    this.cleanState()
  }
}
</script>
